import { Auth } from "aws-amplify";

export const getCurrentSession = async () => {
  const current_session = await Auth.currentSession();
  return current_session;
};
